import React from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import classNames from 'classnames';
var renderers = {
  heading: function heading(props) {
    var level = props.level;
    return React.createElement("div", {
      className: classNames('font-family-system font-weight-semibold', {
        'shade-10': level === 1,
        'shade-20': level > 1
      })
    }, props.children);
  },
  list: function list(props) {
    if (props.ordered) {
      return React.createElement("ol", {
        className: "padding-left-medium"
      }, props.children);
    }

    return React.createElement("ul", {
      className: "padding-left-medium line-height-larger"
    }, props.children);
  },
  listItem: function listItem(props) {
    return React.createElement("li", {
      style: {
        listStyle: 'disc'
      }
    }, props.children);
  },
  code: function code(props) {
    return React.createElement("pre", {
      className: "margin-vertical-small"
    }, React.createElement("code", {
      style: {
        whiteSpace: 'pre-wrap',
        backgroundColor: 'initial'
      }
    }, props.value));
  },
  image: function image(props) {
    return React.createElement("img", {
      src: props.src,
      alt: props.alt,
      title: props.title,
      className: "margin-vertical-normal",
      style: {
        maxWidth: '100%'
      }
    });
  },
  paragraph: function paragraph(props) {
    return React.createElement("p", null, props.children);
  }
};
export default function TileMarkdown(_ref) {
  var markdown = _ref.markdown;
  return React.createElement(ReactMarkdown, {
    escapeHtml: true,
    source: markdown,
    className: "shade-20 line-height-larger",
    renderers: renderers
  });
}
TileMarkdown.propTypes = {
  markdown: PropTypes.string.isRequired
};